import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import Dialog from '@material-ui/core/Dialog';

import { AppStyles, AppTheme } from '../styles/AppTheme';
import { CustomMessageDialogStyles } from '../styles/CustomStyles';
import { AppConfig } from '../AppConfig';
import { AppHelper } from '../helpers/AppHelper';
import { UiHelper } from '../common/helpers/UiHelper';

import { Fade, Slide } from '@material-ui/core';
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction='up' ref={ref} {...props} />;
});

export class DisplayPreviewDialog extends Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  onCloseModal() {
    this.props.onClosed()
  }

  render() {
    const mediaType = (this.props.mediaType || '').toLowerCase()
    const useMediaTypePreview = !!this.props.mediaType
    const videoPreview = (
      <video controls className={this.props.contentVideoStyle ? this.props.contentVideoStyle : css(useMediaTypePreview ? Styles.mediaTypeContentVideo : Styles.contentVideo)} autoPlay preload='metadata'>
        <source src={this.props.adLink} type='video/mp4' />
      </video>
    )

    const imagePreview = (
      <img src={this.props.adLink} className={this.props.contentImageStyle ? this.props.contentImageStyle : css(useMediaTypePreview ? Styles.mediaTypeContentImage : Styles.contentImage)} alt={this.props.title || 'preview'} />
    )

    const unavailablePreview = (
      <div className={css(Styles.unsupportedContent)}>
        <div className={css(Styles.unsupportedTitle)}>Preview not available for this media type</div>
        <div className={css(Styles.unsupportedText)}>{mediaType || 'Unknown type'}</div>
      </div>
    )

    let previewType = 'image'

    if (mediaType) {
      if (mediaType.startsWith('video/')) {
        previewType = 'video'
      } else if (mediaType.startsWith('image/')) {
        previewType = 'image'
      } else {
        previewType = 'unavailable'
      }
    } else if (AppHelper.isVideoContent(this.props.adLink)) {
      previewType = 'video'
    }

    const previewContent = previewType === 'video'
      ? videoPreview
      : previewType === 'unavailable'
        ? unavailablePreview
        : imagePreview

    return (
      <Dialog
        open={this.props.isOpen}
        aria-labelledby={this.props.title}
        fullWidth={this.props.fullWidth ? true : AppHelper.fullWidthCondition()}
        fullScreen={AppHelper.fullWidthCondition()}
        TransitionComponent={window.innerWidth < 1024 ? Transition : Fade}
        maxWidth='md'
        classes={{
          root: css(Styles.root),
          paper: css(Styles.paper),
        }}
      >
        <div className={css([Styles.modalHeader, AppStyles.modalHeader])}>
          <div className={css(Styles.modalTitle)}>{this.props.title}</div>
          <button className={css(Styles.modalCloseButton)} onClick={this.onCloseModal.bind(this)} disabled={this.state.inProcess}>
            {UiHelper.renderImg({key:'dialogCloseIcon'})}
          </button>
        </div>
        <div className={ this.props.modalContentStyle ? this.props.modalContentStyle : css(useMediaTypePreview ? Styles.mediaTypeModalContent : Styles.modalContent)}>
          <div className={css(useMediaTypePreview ? Styles.mediaTypeFrame : Styles.mediaFrame)}>
            {previewContent}
          </div>
          {this.props.children}
        </div>
      </Dialog>
    );
  }
}

const Styles = AppConfig.CUSTOM_STYLE ? CustomMessageDialogStyles : StyleSheet.create({
  modalHeader: {
    padding: 20,
    paddingLeft: 30,
    paddingRight: 30,
    paddingBottom: 14
  },
  modalTitle: {
    color: '#222222',
    fontSize: 18,
    maxWidth: 180,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
  },
  modalContent: {
    maxWidth: 400,
    minWidth: 200,
    paddingTop: 16,
    paddingLeft: 30,
    paddingRight: 30,
    paddingBottom: 30,
  },
  modalCloseButton: {
    position: 'absolute',
    top: 23,
    right: 30,
    padding: 0,
    border: 'none',
    backgroundColor: 'transparent',
    display: 'flex',
    outline: 'none',
    cursor: 'pointer',
  },
  modalCloseIcon: {
    width: 18,
    height: 18,
    padding: 1,
    fill: 'black',
    borderRadius: AppTheme.borderRadius
  },
  root: {
    zIndex: 13000,
  },
  paper: {
    borderRadius: AppTheme.borderRadius,
    '@media (max-width: 1024px)': {
      maxHeight: 'calc(100% - 140px) !important',
      borderRadius: '20px 20px 0 0',
      bottom: '0 !important',
      position: 'fixed',
      height: 'auto !important'
    }
  },
  contentImage: {
    maxWidth: '100%',
    maxHeight: 400,
    border: 'solid black 1px'
  },
  contentVideo: {
    width: '100%',
    height: 'auto',
    maxHeight: 400
  },
  mediaTypeModalContent: {
    width: 460,
    maxWidth: '100%',
    minWidth: 260,
    paddingTop: 16,
    paddingLeft: 30,
    paddingRight: 30,
    paddingBottom: 30,
  },
  mediaFrame: {
    maxWidth: '100%',
    height: 'auto',
  },
  mediaTypeFrame: {
    width: '100%',
    height: 320,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
    backgroundColor: '#F5F6FA',
    borderRadius: AppTheme.borderRadius
  },
  unsupportedContent: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 24,
    textAlign: 'center',
    boxSizing: 'border-box'
  },
  unsupportedTitle: {
    fontSize: 18,
    fontWeight: 600,
    color: '#222222',
    marginBottom: 8
  },
  unsupportedText: {
    fontSize: 14,
    color: '#6B7280',
    marginBottom: 16,
    wordBreak: 'break-word'
  },
  mediaTypeContentImage: {
    display: 'block',
    maxWidth: '100%',
    maxHeight: 320,
    width: 'auto',
    height: 'auto',
    objectFit: 'contain',
    border: 'solid black 1px',
    boxSizing: 'border-box'
  },
  mediaTypeContentVideo: {
    display: 'block',
    width: '100%',
    maxWidth: '100%',
    height: '100%',
    objectFit: 'contain',
    backgroundColor: '#000000'
  }
})



// WEBPACK FOOTER //
// ./src/components/DisplayPreviewDialog.js